import React, { useState } from 'react'
import './contactbody.css'
import { Container, Row } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { TextareaAutosize } from '@mui/material';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import 'react-phone-number-input/style.css'
// import PhoneInput, { formatPhoneNumber, isPossiblePhoneNumber }  from 'react-phone-number-input'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber }  from 'react-phone-number-input'


// import FormHelperText from '@mui/material/FormHelperText';
import { useFormik } from 'formik';
import { signUpSchema } from "./Signupschema";

import leftbottom from '../images/contact-left.webp'
import righttop from '../images/contact-right.webp'

import leftbottommb from '../images/contact-right-mb.webp'
import righttopmb from '../images/contact-left-mb.webp'

const initialValues = {
    name: "",
    company: "",
    nationality:"",
    jobtitle: "",
    // country: "",
    email: "",
    phone: "",
    // message: "",

}

let countries = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D\'Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People\'S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' }  
];

const Contactbody = ({selectedLanguage}) => {

    const [hide, setHide] = useState(false);
    const [modalShow, setModalShow] = useState();
    const [phone, setphone] = useState();
    const [phoneerrmsg, setphoneerrmsg] = useState();
    // const [resonseMsg, setresonseMsg] = useState();
  

    // const [nationality, setNationality] = useState('');
    // const handleChange1 = (event) => {
    //     setNationality(event.target.value);
    // };


    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: signUpSchema,
            onSubmit: (values, action) => {

                if(formatPhoneNumber(phone) === "") {
                    setphoneerrmsg("Please enter your Phone Number")
                } else {
                    setphoneerrmsg();
                    // console.log(
                    //     values
                    // );

                    // var data  =  JSON.stringify({
                    //     name: values.name,
                    //     company: values.company,
                    //     nationality: values.nationality,
                    //     jobtitle: values.jobtitle,
                    //     email: values.email,
                    //     phone: formatPhoneNumberIntl(phone),
                    //     message: values.message,
                    // });
                    
                    // console.log(data);

                    const formData = new FormData();
                    formData.append("name", values.name);
                    formData.append("company", values.company);
                    formData.append("nationality", values.nationality);
                    formData.append("jobtitle", values.jobtitle);
                    formData.append("email", values.email);
                    formData.append("phone",  formatPhoneNumberIntl(phone));
                    formData.append("message", values.message);

                    setHide(true);

                    // https://blog.mxb.sa/wp-json/mail/getintouch
                    // https://oneweb.agency/mail/contact_mail.php
                    // https://blog.oneweb.agency/wp-json/mail/getintouch
                    fetch('https://blog.mxb.sa/wp-json/mail/getintouch', {
                        method: 'POST',
                        // mode: 'no-cors',
                        // headers: {
                        // 'Content-Type': 'application/json',
                        // },
                        
                        // body: JSON.stringify({
                        //     name: values.name,
                        //     company: values.company,
                        //     nationality: values.nationality,
                        //     jobtitle: values.jobtitle,
                        //     email: values.email,
                        //     phone: formatPhoneNumberIntl(phone),
                        //     message: values.message,
                        // }),
                                body:formData,
                            })
                        // .then(res => res.json())
                        .then(data => {
                            // enter you logic when the fetch is successful
                            console.log(data)
                            
                            setHide(false);
                            setModalShow(true);
                    
                        })
                        .catch(error => {
                            // enter your logic for when there is an error (ex. error toast)
                            console.log(error);
                        }) 
                       
                    setphone("");
                    action.resetForm();
                }
            },
        });
    // console.log(

    //     errors
    // );
    return (
        <>
            <section className={(selectedLanguage === "en") ? 'contactbody-section' : 'contactbody-section ar' }>
                <div className='leftbottom '
                    data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-in-sine"
                    data-aos-anchor=".contactbody-section" data-aos-anchor-placement='top-center'
                >
                    <img className='desktop' src={leftbottom} alt='' />
                    <img className='mobile' src={leftbottommb} alt='' />
                </div>
                  <div className='righttop '
                  data-aos={(selectedLanguage === "en") ? "fade-left" : "fade-right" } 
                  data-aos-offset="200" data-aos-easing="ease-in-sine"
                  data-aos-anchor=".contactbody-section" data-aos-anchor-placement='top-center'
                 >
                    <img className='desktop' src={righttop} alt='' />
                    <img className='mobile' src={righttopmb} alt='' />
                  </div>
            
                <Container fluid>
                    <Row>
                        <div className='col-md-6 form-container relative'>
                            {/* <Container> */}
                            {/* <Row>
                                <Col > */}
                                    <div className='contact-form'>
                                        {(selectedLanguage === "en") ? <>
                                            <p className='contactform-para'>Thank you for your interest in MXB<br /> Investment. For inquiries, please fill<br /> out the form below.</p>
                                            <p className='contactform-heading'>Leave us a message</p>
                                        </> : <>
                                            <p className='contactform-para'>شكرًا لك على اهتمامك بشركة مكسب للاستثمار. للاستفسارات، يُرجى ملء النموذج أدناه.</p>
                                            {/* <p className='contactform-heading'>Leave us a message</p> */}
                                        </> }
                                     
                                        {/* <form onSubmit={handleSubmit}> */}
                                            <Box component="form"
                                                onSubmit={handleSubmit}
    
                                                sx={{
                                                    '& .MuiTextField-root': {  width: '100%' },
                                                }} className={(selectedLanguage === "en") ? 'padding-right' : 'padding-left' } >
                                                <div className='mt-4'>
                                                    <TextField id="name" label={(selectedLanguage === "en") ? "Name*" : "الاسم*" } variant="outlined" value={values.name}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur} />
                                                    <div className='errormsg'> {errors.name && touched.name ? (
                                                        <p className="form-error">{errors.name}</p>
                                                    ) : null}</div>
                                                </div>
                                                <div className='mt-4'>
                                                    <TextField id="company" label={(selectedLanguage === "en") ? "Company Name*" : "اسم الشركة*" } variant="outlined" value={values.company}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name="company" />
                                                       
                                                    <div className='errormsg'> {errors.company && touched.company ? (
                                                        <p className="form-error">{errors.company}</p>
                                                    ) : null}</div>
                                                </div>
                                                <div className='mt-4'>
                                                 <FormControl className='w-100' >
                                                    <InputLabel id="Nationality">{(selectedLanguage === "en") ? "Nationality*" : "المسمى الوظيفي*" } </InputLabel>
                                                    <Select
                                                        labelId="Nationality"
                                                        value={values.nationality}
                                                        // value={nationality}
                                                        label="Nationality"
                                                        name="nationality"
                                                        // variant="outlined"
                                                        onChange={handleChange}
                                                        className='w-100'
                                                    >

                                                    {countries.map((country) => {
                                                        return <MenuItem key={country.code} value={country.name}>{country.name} ({country.code})</MenuItem>
                                                        // <option key={country.code} value={country.name}>{country.name} ({country.code})</option>
                                                    })}    
                                                        
                                                        {/* <MenuItem value={20}>Twenty</MenuItem>
                                                        <MenuItem value={30}>Thirty</MenuItem> */}
                                                    </Select>
                                                    </FormControl>
                                                    <div className='errormsg'> {errors.nationality && touched.nationality ? (
                                                        <p className="form-error">{errors.nationality}</p>
                                                    ) : null}</div>
                                                </div>
                                                <div className='mt-4'>
                                                    <TextField id="jobtitle" label={(selectedLanguage === "en") ? "Job Title*" : "البريد الإلكتروني*" } variant="outlined" value={values.jobtitle}
                                                        name="jobtitle"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur} />
                                                    <div className='errormsg'> {errors.jobtitle && touched.jobtitle ? (
                                                        <p className="form-error">{errors.jobtitle}</p>
                                                    ) : null}</div>
                                                </div>
                                                <div className='mt-4'>
                                                    <TextField id="email" type='email' label={(selectedLanguage === "en") ? "Email Address*" : "البريد الإلكتروني*" } variant="outlined" value={values.email}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name='email' />
                                                    <div className='errormsg'> {errors.email && touched.email ? (
                                                        <p className="form-error">{errors.email}</p>
                                                    ) : null}</div>
                                                </div>
                                                <div className='mt-4'>
                                                    {/* <TextField id="phone" label="phone" variant="outlined" value={values.phone}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name="phone" /> */}
                                                     <PhoneInput placeholder="" name={(selectedLanguage === "en") ? "phone*" : "الجوّال*:" }  aria-labelledby="phone" value={phone}                                                    
                                                        country="US"
                                                       international
                                                       countryCallingCodeEditable={false}
                                                       defaultCountry="SA"
                                                       onChange={setphone}
                                                        // onBlur={handleBlur} 
                                                        rules={{ required: true, validate: isPossiblePhoneNumber }}
                                                        />     
                                                        <div className='errormsg'> {phoneerrmsg ? (
                                                        <p className="form-error">{phoneerrmsg}</p>
                                                    ) : null}</div>

                                                </div>
                                                <div className='mt-4'>
                                                    <TextareaAutosize id="message" label="Your Message" variant="outlined" className='w-100 msgfield' placeholder={(selectedLanguage === "en") ? "Your Message" : "الرسالة" } minRows={5} value={values.message}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur} 
                                                        name="message" />
                                                    <div className='errormsg'> {errors.message && touched.message ? (
                                                        <p className="form-error">{errors.message}</p>
                                                    ) : null}</div>
                                                </div>

                                                <div className='btn-wrap'>
                                                    {(hide) ? (
                                                    <button 
                                                        className='submit-btn'
                                                        disabled
                                                        style={{opacity:"0.5"}}
                                                        type="submit"
                                                    >
                                                        Submit
                                                    </button>
                                                    
                                                    ) :  (
                                                        <button className='submit-btn' type="submit" >Submit</button>
                                                        )
                                                    }
                                                </div>  
                                            </Box>

                                            
                                        {/* </form> */}
                                    </div>

                                    <div ></div>
                                {/* </Col>
                            </Row> */}
                            {/* </Container> */}
                        </div>

                        <div className='col-md-6 relative d-flex text-start'>
                            <div className='address-div'>
                                {(selectedLanguage === "en") ? <>
                                    <p><svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.5 4.25C6.45833 4.25 5.57292 4.61458 4.84375 5.34375C4.11458 6.07292 3.75 6.95833 3.75 8C3.75 9.04167 4.11458 9.92708 4.84375 10.6562C5.57292 11.3854 6.45833 11.75 7.5 11.75C8.54167 11.75 9.42708 11.3854 10.1562 10.6562C10.8854 9.92708 11.25 9.04167 11.25 8C11.25 6.95833 10.8854 6.07292 10.1562 5.34375C9.42708 4.61458 8.54167 4.25 7.5 4.25ZM7.5 10.5C6.82292 10.5 6.23698 10.2526 5.74219 9.75781C5.2474 9.26302 5 8.67708 5 8C5 7.32292 5.2474 6.73698 5.74219 6.24219C6.23698 5.7474 6.82292 5.5 7.5 5.5C8.17708 5.5 8.76302 5.7474 9.25781 6.24219C9.7526 6.73698 10 7.32292 10 8C10 8.67708 9.7526 9.26302 9.25781 9.75781C8.76302 10.2526 8.17708 10.5 7.5 10.5ZM7.5 0.5C6.14583 0.5 4.89583 0.838542 3.75 1.51562C2.60417 2.19271 1.69271 3.10417 1.01562 4.25C0.338542 5.39583 0 6.64583 0 8C0 8.83333 0.104167 9.57552 0.3125 10.2266C0.520833 10.8516 0.924479 11.6328 1.52344 12.5703C1.9401 13.2214 2.79948 14.4844 4.10156 16.3594L6.71875 20.1094C6.90104 20.3698 7.16146 20.5 7.5 20.5C7.83854 20.5 8.09896 20.3698 8.28125 20.1094L10.8984 16.3594C12.2005 14.4844 13.0599 13.2214 13.4766 12.5703C14.0755 11.6328 14.4792 10.8516 14.6875 10.2266C14.8958 9.57552 15 8.83333 15 8C15 6.64583 14.6615 5.39583 13.9844 4.25C13.3073 3.10417 12.3958 2.19271 11.25 1.51562C10.1042 0.838542 8.85417 0.5 7.5 0.5ZM7.5 19.0156C6.875 18.1042 6.06771 16.9453 5.07812 15.5391C3.82812 13.7422 3.00781 12.5573 2.61719 11.9844C2.07031 11.099 1.70573 10.3958 1.52344 9.875C1.34115 9.32812 1.25 8.70312 1.25 8C1.25 7.16667 1.40625 6.3724 1.71875 5.61719C2.03125 4.86198 2.48698 4.1849 3.08594 3.58594C3.6849 2.98698 4.36198 2.53125 5.11719 2.21875C5.8724 1.90625 6.66667 1.75 7.5 1.75C8.33333 1.75 9.1276 1.90625 9.88281 2.21875C10.638 2.53125 11.3151 2.98698 11.9141 3.58594C12.513 4.1849 12.9688 4.86198 13.2812 5.61719C13.5938 6.3724 13.75 7.16667 13.75 8C13.75 8.70312 13.6589 9.32812 13.4766 9.875C13.2943 10.3958 12.9297 11.099 12.3828 11.9844C11.9922 12.5573 11.1719 13.7422 9.92188 15.5391L7.5 19.0156Z" fill="white" />
                                    </svg><span className='address-paragraph'><a target='blank' href="https://goo.gl/mapswFx13yZu1pN5eEBJ9">Al Takhassousi street, Olaya District, Riyadh</a></span><br /><span className='address-paragraph leftpadding1'><a target='blank' href="https://goo.gl/mapswFx13yZu1pN5eEBJ9"> 12333 Kingdom of Saudi Arabia</a></span></p>
                                    <p><svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.5 4.25C6.45833 4.25 5.57292 4.61458 4.84375 5.34375C4.11458 6.07292 3.75 6.95833 3.75 8C3.75 9.04167 4.11458 9.92708 4.84375 10.6562C5.57292 11.3854 6.45833 11.75 7.5 11.75C8.54167 11.75 9.42708 11.3854 10.1562 10.6562C10.8854 9.92708 11.25 9.04167 11.25 8C11.25 6.95833 10.8854 6.07292 10.1562 5.34375C9.42708 4.61458 8.54167 4.25 7.5 4.25ZM7.5 10.5C6.82292 10.5 6.23698 10.2526 5.74219 9.75781C5.2474 9.26302 5 8.67708 5 8C5 7.32292 5.2474 6.73698 5.74219 6.24219C6.23698 5.7474 6.82292 5.5 7.5 5.5C8.17708 5.5 8.76302 5.7474 9.25781 6.24219C9.7526 6.73698 10 7.32292 10 8C10 8.67708 9.7526 9.26302 9.25781 9.75781C8.76302 10.2526 8.17708 10.5 7.5 10.5ZM7.5 0.5C6.14583 0.5 4.89583 0.838542 3.75 1.51562C2.60417 2.19271 1.69271 3.10417 1.01562 4.25C0.338542 5.39583 0 6.64583 0 8C0 8.83333 0.104167 9.57552 0.3125 10.2266C0.520833 10.8516 0.924479 11.6328 1.52344 12.5703C1.9401 13.2214 2.79948 14.4844 4.10156 16.3594L6.71875 20.1094C6.90104 20.3698 7.16146 20.5 7.5 20.5C7.83854 20.5 8.09896 20.3698 8.28125 20.1094L10.8984 16.3594C12.2005 14.4844 13.0599 13.2214 13.4766 12.5703C14.0755 11.6328 14.4792 10.8516 14.6875 10.2266C14.8958 9.57552 15 8.83333 15 8C15 6.64583 14.6615 5.39583 13.9844 4.25C13.3073 3.10417 12.3958 2.19271 11.25 1.51562C10.1042 0.838542 8.85417 0.5 7.5 0.5ZM7.5 19.0156C6.875 18.1042 6.06771 16.9453 5.07812 15.5391C3.82812 13.7422 3.00781 12.5573 2.61719 11.9844C2.07031 11.099 1.70573 10.3958 1.52344 9.875C1.34115 9.32812 1.25 8.70312 1.25 8C1.25 7.16667 1.40625 6.3724 1.71875 5.61719C2.03125 4.86198 2.48698 4.1849 3.08594 3.58594C3.6849 2.98698 4.36198 2.53125 5.11719 2.21875C5.8724 1.90625 6.66667 1.75 7.5 1.75C8.33333 1.75 9.1276 1.90625 9.88281 2.21875C10.638 2.53125 11.3151 2.98698 11.9141 3.58594C12.513 4.1849 12.9688 4.86198 13.2812 5.61719C13.5938 6.3724 13.75 7.16667 13.75 8C13.75 8.70312 13.6589 9.32812 13.4766 9.875C13.2943 10.3958 12.9297 11.099 12.3828 11.9844C11.9922 12.5573 11.1719 13.7422 9.92188 15.5391L7.5 19.0156Z" fill="white" />
                                    </svg><span className='address-paragraph'><a target='blank' className='text-decoration-underline' href="https://goo.gl/mapswFx13yZu1pN5eEBJ9">https://goo.gl/mapswFx13yZu1pN5eEBJ9</a></span></p>
                                    
                                    <p><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z" /></svg><span className='address-paragraph2'><a href="mailto:info@mxb.sa"> info@mxb.sa</a> </span></p>
                                    <p><span className='address-paragraph2 leftpadding'>UAN : 9200 19927</span></p>
                                </> : <>
                                    <h2 className='text-white'>موقع المكتب</h2>
                                    <p><svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.5 4.25C6.45833 4.25 5.57292 4.61458 4.84375 5.34375C4.11458 6.07292 3.75 6.95833 3.75 8C3.75 9.04167 4.11458 9.92708 4.84375 10.6562C5.57292 11.3854 6.45833 11.75 7.5 11.75C8.54167 11.75 9.42708 11.3854 10.1562 10.6562C10.8854 9.92708 11.25 9.04167 11.25 8C11.25 6.95833 10.8854 6.07292 10.1562 5.34375C9.42708 4.61458 8.54167 4.25 7.5 4.25ZM7.5 10.5C6.82292 10.5 6.23698 10.2526 5.74219 9.75781C5.2474 9.26302 5 8.67708 5 8C5 7.32292 5.2474 6.73698 5.74219 6.24219C6.23698 5.7474 6.82292 5.5 7.5 5.5C8.17708 5.5 8.76302 5.7474 9.25781 6.24219C9.7526 6.73698 10 7.32292 10 8C10 8.67708 9.7526 9.26302 9.25781 9.75781C8.76302 10.2526 8.17708 10.5 7.5 10.5ZM7.5 0.5C6.14583 0.5 4.89583 0.838542 3.75 1.51562C2.60417 2.19271 1.69271 3.10417 1.01562 4.25C0.338542 5.39583 0 6.64583 0 8C0 8.83333 0.104167 9.57552 0.3125 10.2266C0.520833 10.8516 0.924479 11.6328 1.52344 12.5703C1.9401 13.2214 2.79948 14.4844 4.10156 16.3594L6.71875 20.1094C6.90104 20.3698 7.16146 20.5 7.5 20.5C7.83854 20.5 8.09896 20.3698 8.28125 20.1094L10.8984 16.3594C12.2005 14.4844 13.0599 13.2214 13.4766 12.5703C14.0755 11.6328 14.4792 10.8516 14.6875 10.2266C14.8958 9.57552 15 8.83333 15 8C15 6.64583 14.6615 5.39583 13.9844 4.25C13.3073 3.10417 12.3958 2.19271 11.25 1.51562C10.1042 0.838542 8.85417 0.5 7.5 0.5ZM7.5 19.0156C6.875 18.1042 6.06771 16.9453 5.07812 15.5391C3.82812 13.7422 3.00781 12.5573 2.61719 11.9844C2.07031 11.099 1.70573 10.3958 1.52344 9.875C1.34115 9.32812 1.25 8.70312 1.25 8C1.25 7.16667 1.40625 6.3724 1.71875 5.61719C2.03125 4.86198 2.48698 4.1849 3.08594 3.58594C3.6849 2.98698 4.36198 2.53125 5.11719 2.21875C5.8724 1.90625 6.66667 1.75 7.5 1.75C8.33333 1.75 9.1276 1.90625 9.88281 2.21875C10.638 2.53125 11.3151 2.98698 11.9141 3.58594C12.513 4.1849 12.9688 4.86198 13.2812 5.61719C13.5938 6.3724 13.75 7.16667 13.75 8C13.75 8.70312 13.6589 9.32812 13.4766 9.875C13.2943 10.3958 12.9297 11.099 12.3828 11.9844C11.9922 12.5573 11.1719 13.7422 9.92188 15.5391L7.5 19.0156Z" fill="white" />
                                    </svg><span className='address-paragraph'><a target='blank' href="https://goo.gl/mapswFx13yZu1pN5eEBJ9">شارع التخصصي، حي العليا، الرياض 12333</a></span><br /><span className='address-paragraph leftpadding1'><a target='blank' href="https://goo.gl/mapswFx13yZu1pN5eEBJ9">  المملكة العربية السعودية</a></span></p>
                                    <p><svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.5 4.25C6.45833 4.25 5.57292 4.61458 4.84375 5.34375C4.11458 6.07292 3.75 6.95833 3.75 8C3.75 9.04167 4.11458 9.92708 4.84375 10.6562C5.57292 11.3854 6.45833 11.75 7.5 11.75C8.54167 11.75 9.42708 11.3854 10.1562 10.6562C10.8854 9.92708 11.25 9.04167 11.25 8C11.25 6.95833 10.8854 6.07292 10.1562 5.34375C9.42708 4.61458 8.54167 4.25 7.5 4.25ZM7.5 10.5C6.82292 10.5 6.23698 10.2526 5.74219 9.75781C5.2474 9.26302 5 8.67708 5 8C5 7.32292 5.2474 6.73698 5.74219 6.24219C6.23698 5.7474 6.82292 5.5 7.5 5.5C8.17708 5.5 8.76302 5.7474 9.25781 6.24219C9.7526 6.73698 10 7.32292 10 8C10 8.67708 9.7526 9.26302 9.25781 9.75781C8.76302 10.2526 8.17708 10.5 7.5 10.5ZM7.5 0.5C6.14583 0.5 4.89583 0.838542 3.75 1.51562C2.60417 2.19271 1.69271 3.10417 1.01562 4.25C0.338542 5.39583 0 6.64583 0 8C0 8.83333 0.104167 9.57552 0.3125 10.2266C0.520833 10.8516 0.924479 11.6328 1.52344 12.5703C1.9401 13.2214 2.79948 14.4844 4.10156 16.3594L6.71875 20.1094C6.90104 20.3698 7.16146 20.5 7.5 20.5C7.83854 20.5 8.09896 20.3698 8.28125 20.1094L10.8984 16.3594C12.2005 14.4844 13.0599 13.2214 13.4766 12.5703C14.0755 11.6328 14.4792 10.8516 14.6875 10.2266C14.8958 9.57552 15 8.83333 15 8C15 6.64583 14.6615 5.39583 13.9844 4.25C13.3073 3.10417 12.3958 2.19271 11.25 1.51562C10.1042 0.838542 8.85417 0.5 7.5 0.5ZM7.5 19.0156C6.875 18.1042 6.06771 16.9453 5.07812 15.5391C3.82812 13.7422 3.00781 12.5573 2.61719 11.9844C2.07031 11.099 1.70573 10.3958 1.52344 9.875C1.34115 9.32812 1.25 8.70312 1.25 8C1.25 7.16667 1.40625 6.3724 1.71875 5.61719C2.03125 4.86198 2.48698 4.1849 3.08594 3.58594C3.6849 2.98698 4.36198 2.53125 5.11719 2.21875C5.8724 1.90625 6.66667 1.75 7.5 1.75C8.33333 1.75 9.1276 1.90625 9.88281 2.21875C10.638 2.53125 11.3151 2.98698 11.9141 3.58594C12.513 4.1849 12.9688 4.86198 13.2812 5.61719C13.5938 6.3724 13.75 7.16667 13.75 8C13.75 8.70312 13.6589 9.32812 13.4766 9.875C13.2943 10.3958 12.9297 11.099 12.3828 11.9844C11.9922 12.5573 11.1719 13.7422 9.92188 15.5391L7.5 19.0156Z" fill="white" />
                                    </svg><span className='address-paragraph'><a target='blank' className='text-decoration-underline' href="https://goo.gl/mapswFx13yZu1pN5eEBJ9">https://goo.gl/mapswFx13yZu1pN5eEBJ9</a></span></p>
                                    
                                    <p><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z" /></svg><span className='address-paragraph2'> البريد الإلكتروني:<a href="mailto:info@mxb.sa">  info@mxb.sa</a> </span></p>
                                    <p><span className='address-paragraph2 leftpadding'>رقم الاتصال العالمي: <span style={{direction:"ltr"}}>920019927</span></span></p>
                                </> }
                                
                                   
                                   
                                   <div  className='framemap' >
                                       <iframe title='Google Map'style={{ border: 0 }} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14497.881150576583!2d46.6608874!3d24.7107298!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f1de1e36de813%3A0xdb3ff66e3043572a!2sMXB%20INVESTMENT%20COMPANY!5e0!3m2!1sen!2sin!4v1688988599259!5m2!1sen!2sin" width="400" height="350" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                   </div>
                            </div>
                        </div>
                    </Row>
                </Container >



                    {/* success popup */}
                    <Modal
                        show={modalShow}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        >
                        {/* <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                            Modal heading
                            </Modal.Title>
                        </Modal.Header> */}
                        <Modal.Body className='text-center p-5'>
                            {/* {resonseMsg} */}
                            
                            {(selectedLanguage === "en") ?
                                <>
                                    <h4>Thank you for contacting MXB!</h4>
                                    <p className='px-5'>We’ve received your message and look forward to assisting you.</p>
                                </>
                                :
                                <> <h4>Success!</h4>
                                 <p className='px-5'>شكرا لك على تواصلك مع شركتنا لقد استقبلنا رسالتك وسوف يتواصل معك أحد موظفي فريق مكسب!</p>
                                </>
                                
                                }
                            <button className='close-btn' onClick={() => setModalShow(false)} >Ok</button>
                        </Modal.Body>
                        {/* <Modal.Footer>
                            
                        </Modal.Footer> */}
                    </Modal>

            </section >
        </>
    )
}

export default Contactbody